(function () {
  function getSelectedSize() {
    // Shopify variant select (dropdown themes)
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }

    // Shopify variant radio buttons (pill/button themes)
    const variantRadio = document.querySelector('input[name="id"]:checked');
    if (variantRadio && variantRadio.value) {
      return variantRadio.value;
    }

    return null;
  }

  function getSelectedSizeLabel() {
    // Try to find the selected size option label so we can match it on the next page
    const sizeFieldset = document.querySelector(
      '.product-form__input input[type="radio"]:checked'
    );
    if (sizeFieldset) {
      return sizeFieldset.value;
    }

    const sizeSelect = document.querySelector('select[name="id"]');
    if (sizeSelect) {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      return selectedOption ? selectedOption.text : null;
    }

    return null;
  }

  function buildUrl(baseUrl, variantId) {
    if (variantId) {
      return baseUrl + '?variant=' + variantId;
    }
    return baseUrl;
  }

  function markSelectedSwatch() {
    const radios = document.querySelectorAll('.product-selection-radio');
    radios.forEach(function (radio) {
      const url = radio.getAttribute('data-url');
      if (url && window.location.pathname === url) {
        radio.checked = true;
      }
    });
  }

  function init() {
    markSelectedSwatch();

    const radios = document.querySelectorAll('.product-selection-radio');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        const targetUrl = this.getAttribute('data-url');
        if (!targetUrl) return;

        // Store selected size label in sessionStorage so the next page can restore it
        const sizeLabel = getSelectedSizeLabel();
        if (sizeLabel) {
          sessionStorage.setItem('tus_selected_size', sizeLabel);
        }

        // Try to get current variant ID to pass along
        const variantId = getSelectedSize();
        window.location.href = buildUrl(targetUrl, variantId);
      });
    });
  }

  function restoreSize() {
    const savedSize = sessionStorage.getItem('tus_selected_size');
    if (!savedSize) return;

    // Try to select the matching size radio on the new page
    const sizeRadios = document.querySelectorAll(
      '.product-form__input input[type="radio"]'
    );

    sizeRadios.forEach(function (radio) {
      if (
        radio.name !== 'productColour' &&
        radio.value.toLowerCase() === savedSize.toLowerCase()
      ) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        sessionStorage.removeItem('tus_selected_size');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      restoreSize();
    });
  } else {
    init();
    restoreSize();
  }
})();